import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { createPluginState, getPluginState } from './plugin-factory';
import { findReplacePluginKey } from './plugin-key';
export var initialState = {
  isActive: false,
  shouldFocus: false,
  findText: '',
  replaceText: '',
  index: 0,
  matches: [],
  decorationSet: DecorationSet.empty,
  shouldMatchCase: false
};
export var createPlugin = function createPlugin(dispatch) {
  return new SafePlugin({
    key: findReplacePluginKey,
    state: createPluginState(dispatch, function () {
      return initialState;
    }),
    props: {
      decorations: function decorations(state) {
        var _getPluginState = getPluginState(state),
          isActive = _getPluginState.isActive,
          findText = _getPluginState.findText,
          decorationSet = _getPluginState.decorationSet;
        if (isActive && findText) {
          return decorationSet;
        }
      }
    }
  });
};